import { string } from 'prop-types';
import React from 'react';
import Truncate from 'react-truncate';
import { translate } from '../Services/translation';

const ItemScrollPromo = ({ item, index, smallTitle }) => (
    <div className="promo__item" key={index}>
        <a href={item.linkUrl}>
            {item.imageHtml ? (
                <div dangerouslySetInnerHTML={{ __html: item.imageHtml }}></div>
                // <img src={item.imageUrl} className="promo__image"></img>
            ) : (<span className="product__image--missing">{translate('product.noproductimage')}</span>)}
        </a>
        <div className="promo__container">
            <a href={item.linkUrl}><h3 className={item.disablePromoTextsInDesktop ? 'promo__title hidden-lg' : 'promo__title' + smallTitle}>{item.title}</h3></a>
            <div className={item.disablePromoTextsInDesktop ? 'promo__text hidden-lg' : 'promo__text'} >
                <Truncate lines={5} ellipsis={<span>...</span>}>
                    <span className="promo__text">{item.text}</span>
                </Truncate>
            </div>
            <a className={item.title ? 'promo__button button Hide-on-Mobile' : 'promo__button button button--arrow-right'} href={item.linkUrl}>{item.linkText}</a>
        </div>
    </div>
)
export default ItemScrollPromo;
